"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const levels_1 = __importDefault(require("../constants/levels"));
const unitsPerTile_1 = __importDefault(require("../constants/unitsPerTile"));
class State {
    constructor() {
        this._activeDestructibleIDs = [];
        this._app = null;
        this._bonked = false;
        this._brokenDestructibleIDs = [];
        this._cootsCoords = {
            x: levels_1.default[0].startingTileX * unitsPerTile_1.default,
            y: levels_1.default[0].startingTileY * unitsPerTile_1.default
        };
        this._cootsVelocityX = 0;
        this._cootsVelocityY = 0;
        this._currentTime = 0;
        this._heldKeys = [];
        this._hitObstacleAt = null;
        this._isAtTitle = false;
        this._isAwaitingFocus = true;
        this._isInBed = true;
        this._level = levels_1.default[0];
        this._levelCompletedAt = null;
        this._levelStartedAt = null;
        this._loadedAssets = 0;
        this._mouseScreenCoords = null;
        this._pauses = [];
        this._playedDefeatMusic = false;
        this._playedLevelMusic = false;
        this._recentDestruction = null;
        this._won = false;
        this._ySortEntries = [];
    }
    get app() {
        if (this._app !== null) {
            return this._app;
        }
        throw new Error(this.getAccessorErrorMessage("app"));
    }
    get activeDestructibleIDs() {
        return [...this._activeDestructibleIDs];
    }
    get bonked() {
        return this._bonked;
    }
    get brokenDestructibleIDs() {
        return [...this._brokenDestructibleIDs];
    }
    get cootsCoords() {
        return this._cootsCoords;
    }
    get cootsVelocityX() {
        return this._cootsVelocityX;
    }
    get cootsVelocityY() {
        return this._cootsVelocityY;
    }
    get currentTime() {
        return this._currentTime;
    }
    get heldKeys() {
        return [...this._heldKeys];
    }
    get hitObstacleAt() {
        if (this._hitObstacleAt !== null) {
            return this._hitObstacleAt;
        }
        throw new Error(this.getAccessorErrorMessage("hitObstacleAt"));
    }
    get isAtTitle() {
        return this._isAtTitle;
    }
    get isAwaitingFocus() {
        return this._isAwaitingFocus;
    }
    get isInBed() {
        return this._isInBed;
    }
    get level() {
        return this._level;
    }
    get levelCompletedAt() {
        if (this._levelCompletedAt !== null) {
            return this._levelCompletedAt;
        }
        throw new Error("levelCompletedAt");
    }
    get levelStartedAt() {
        if (this._levelStartedAt !== null) {
            return this._levelStartedAt;
        }
        throw new Error("levelStartedAt");
    }
    get loadedAssets() {
        return this._loadedAssets;
    }
    get mouseScreenCoords() {
        if (this._mouseScreenCoords !== null) {
            return this._mouseScreenCoords;
        }
        throw new Error(this.getAccessorErrorMessage("mouseCoords"));
    }
    get pauses() {
        return [...this._pauses];
    }
    get playedDefeatMusic() {
        return this._playedDefeatMusic;
    }
    get playedLevelMusic() {
        return this._playedLevelMusic;
    }
    get recentDestruction() {
        if (this._recentDestruction !== null) {
            return this._recentDestruction;
        }
        throw new Error(this.getAccessorErrorMessage("clawedAt"));
    }
    get ySortEntries() {
        return [...this._ySortEntries];
    }
    get won() {
        return this._won;
    }
    set activeDestructibleIDs(activeDestructibleIDs) {
        this._activeDestructibleIDs = [...activeDestructibleIDs];
    }
    set app(app) {
        this._app = app !== null ? app : null;
    }
    set bonked(bonked) {
        this._bonked = bonked;
    }
    set brokenDestructibleIDs(brokenDestructibleIDs) {
        this._brokenDestructibleIDs = [...brokenDestructibleIDs];
    }
    set cootsCoords(cootsCoords) {
        this._cootsCoords = cootsCoords;
    }
    set cootsVelocityX(cootsVelocityX) {
        this._cootsVelocityX = cootsVelocityX;
    }
    set cootsVelocityY(cootsVelocityY) {
        this._cootsVelocityY = cootsVelocityY;
    }
    set currentTime(currentTime) {
        this._currentTime = currentTime;
    }
    set heldKeys(heldKeys) {
        this._heldKeys = [...heldKeys];
    }
    set hitObstacleAt(hitObstacleAt) {
        this._hitObstacleAt = hitObstacleAt;
    }
    set isAtTitle(isAtTitle) {
        this._isAtTitle = isAtTitle;
    }
    set isAwaitingFocus(isAwaitingFocus) {
        this._isAwaitingFocus = isAwaitingFocus;
    }
    set isInBed(isInBed) {
        this._isInBed = isInBed;
    }
    set level(level) {
        this._level = level;
    }
    set levelCompletedAt(levelCompletedAt) {
        this._levelCompletedAt = levelCompletedAt;
    }
    set levelStartedAt(levelStartedAt) {
        this._levelStartedAt = levelStartedAt;
    }
    set loadedAssets(loadedAssets) {
        this._loadedAssets = loadedAssets;
    }
    set mouseScreenCoords(mouseScreenCoords) {
        this._mouseScreenCoords = mouseScreenCoords;
    }
    set pauses(pauses) {
        this._pauses = [...pauses];
    }
    set playedDefeatMusic(playedDefeatMusic) {
        this._playedDefeatMusic = playedDefeatMusic;
    }
    set playedLevelMusic(playedLevelMusic) {
        this._playedLevelMusic = playedLevelMusic;
    }
    set recentDestruction(destruction) {
        this._recentDestruction = destruction;
    }
    set won(won) {
        this._won = won;
    }
    set ySortEntries(ySortEntries) {
        this._ySortEntries = [...ySortEntries];
    }
    hasHitObstacleAt() {
        return this._hitObstacleAt !== null;
    }
    hasLevelCompletedAt() {
        return this._levelCompletedAt !== null;
    }
    hasLevelStartedAt() {
        return this._levelStartedAt !== null;
    }
    hasMouseScreenCoords() {
        return this._mouseScreenCoords !== null;
    }
    hasRecentDestruction() {
        return this._recentDestruction !== null;
    }
    getAccessorErrorMessage(property) {
        return `Could not access ${this.constructor.name} ${property}.`;
    }
}
exports.default = State;
